import React from 'react';
import { IconButton, MenuItem, Stack, TextField, Tooltip, Typography } from '@mui/material';
import RemoveIcon from '@mui/icons-material/Remove';
import { ParticipantListParticipant, SettingsOption } from 'src/model/api/v2/data-contracts';
import { ts } from 'src/utils/translate';

export const ROLE_SELECT_WIDTH = 220;

type Props = {
    participant: ParticipantListParticipant;
    roles: SettingsOption[];
    disabled: boolean;
    onRoleChange: (roleId: number) => void;
    onRemove: () => void;
};

export const ParticipantRow = ({ participant, roles, disabled, onRoleChange, onRemove }: Props) => (
    <Stack direction="row" alignItems="center" spacing={1}>
        <Tooltip title={ts('plt_del_par_from_list', 'Remove participant from this list')}>
            <span>
                <IconButton size="small" disabled={disabled} onClick={onRemove}>
                    <RemoveIcon fontSize="small" />
                </IconButton>
            </span>
        </Tooltip>
        <Typography variant="body2" noWrap sx={{ flex: 1, minWidth: 0 }}>{participant.email}</Typography>
        <Tooltip title={ts('plt_mod_par_role', "Change participant's role")} placement="left">
            <TextField
                select
                size="small"
                value={participant.role_id}
                disabled={disabled}
                onChange={(event) => onRoleChange(Number(event.target.value))}
                sx={{ width: ROLE_SELECT_WIDTH, flexShrink: 0 }}
            >
                {roles.map((role) => (
                    <MenuItem key={role.id} value={role.id}>{role.name}</MenuItem>
                ))}
            </TextField>
        </Tooltip>
    </Stack>
);
